import type { AIStore } from '..';
import type { StateCreator } from 'zustand';

import { actionLog } from '@core/store/util';

export type LinterConfigNames = 'errors' | 'styleguide' | 'warnings';

export interface AiLinterSliceState {
  config: Record<LinterConfigNames, string | null>;
  enabled: boolean;
}

interface AiLinterSliceAction {
  updateConfigPrompt: (name: keyof AiLinterSliceState['config'], value: string | null) => void;
}

export interface AiLinterSlice {
  linter: AiLinterSliceAction & AiLinterSliceState;
}

const initialState: AiLinterSliceState = {
  enabled: true,
  config: {
    errors: null,
    warnings: null,
    styleguide: null,
  },
};

export const createAiLinterSlice: StateCreator<
  AIStore,
  [['zustand/devtools', never], ['zustand/immer', never]],
  [],
  AiLinterSlice
> = set => ({
  linter: {
    ...initialState,

    updateConfigPrompt: (name, value) => {
      set(
        state => {
          state.linter.config[name] = value;
        },

        false,
        actionLog('ai.linter.updateConfig', [name, value]),
      );
    },
  },
});
